import { TypographyMuted, TypographySmall } from '@talentmesh/ui/components/typography';
import { RoleItemProps } from '../../Hooks/useRolePickerColumns';

interface RoleColumnCellProps {
    value: RoleItemProps;
}

function RoleColumnCell({ value }: RoleColumnCellProps) {
    return (
        <div className="flex flex-col">
            <TypographySmall className="font-bold">{value.name}</TypographySmall>
            <TypographyMuted className="break-words whitespace-normal">{value.description}</TypographyMuted>
        </div>
    );
}

export default RoleColumnCell;
